import React from "react";

export default function HarvestFrame4({ frameTextToggle, children }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 2000 2000"
      width="300"
      height="300"
      fill="none"
    >
      <g transform={frameTextToggle}>
        <defs>
          <style>
            {
              ".cls-4har8{fill:#d6cb47}.cls-4har9{fill:#e5df61}.cls-4har10{fill:#54a36a}"
            }
          </style>
        </defs>
        <path
          d="M1660.78 243.28H339.21c-52.98 0-95.93 42.95-95.93 95.94v1321.57c0 19.04 5.55 36.77 15.11 51.69a96.236 96.236 0 0 0 33.63 31.84 94.971 94.971 0 0 0 32.66 11.3c4.74.73 9.59 1.1 14.53 1.1h1321.57c26.17 0 49.9-10.48 67.21-27.48 3.43-3.36 6.61-6.99 9.5-10.84.48-.63.95-1.27 1.41-1.92.91-1.27 1.79-2.56 2.63-3.88 4.9-7.6 8.74-15.94 11.33-24.82 2.52-8.56 3.86-17.62 3.86-26.99V339.22c0-52.99-42.95-95.94-95.94-95.94Zm-165.97 1155.78c0 52.88-42.87 95.75-95.75 95.75H600.94c-52.88 0-95.75-42.87-95.75-95.75v-9.71c.14-.77.28-1.54.41-2.33.19-1.09.36-2.19.51-3.31.1-.66.19-1.32.27-1.98.1-.71.19-1.42.26-2.14.08-.59.14-1.17.2-1.77l.06-.54c.24-2.39.43-4.82.57-7.3-.77.12-1.53.25-2.28.39V600.94c0-52.88 42.87-95.75 95.75-95.75h798.12c52.88 0 95.75 42.87 95.75 95.75v798.12Z"
          style={{
            fill: "#b9e1ef",
          }}
        />
        <path
          d="M1756.72 1000c-28.75 34.36-102.85 116.15-219.1 169.87a557.169 557.169 0 0 1-42.81 17.69V818.19c145.23 62.54 235.63 154.04 261.91 181.81Z"
          style={{
            fill: "#d1f2a0",
          }}
        />
        <path
          d="M1756.72 1000v660.79c0 9.37-1.34 18.43-3.86 26.99a94.733 94.733 0 0 1-11.33 24.82c-.84 1.32-1.72 2.61-2.63 3.88-.46.65-.93 1.29-1.41 1.92a95.123 95.123 0 0 1-9.5 10.84c-17.31 17-41.04 27.48-67.21 27.48H339.21c-4.94 0-9.79-.37-14.53-1.1a94.971 94.971 0 0 1-32.66-11.3 96.236 96.236 0 0 1-33.63-31.84c-9.56-14.92-15.11-32.65-15.11-51.69V913.97c77.89-18.54 166.08-32.88 261.91-36.3v492.7c.75-.14 1.51-.27 2.28-.39-.14 2.48-.33 4.91-.57 7.3l-.06.54c-.06.6-.12 1.18-.2 1.77-.07.72-.16 1.43-.26 2.14-.08.66-.17 1.32-.27 1.98a84.78 84.78 0 0 1-.51 3.31c-.13.79-.27 1.56-.41 2.33v9.71c0 52.88 42.87 95.75 95.75 95.75h798.12c52.88 0 95.75-42.87 95.75-95.75v-352.48c79.7-5.56 167.03-19.84 261.91-46.58Z"
          style={{
            fill: "#b8e085",
          }}
        />
        <path
          d="M803.87 505.19H600.94c-52.88 0-95.75 42.87-95.75 95.75V724c-84.26-31.38-144.28-112.55-144.28-207.74 0-122.4 99.22-221.62 221.61-221.62s215.58 93.29 221.35 210.55Z"
          style={{
            fill: "#cdeef7",
          }}
        />
        <path
          d="M1756.72 1226.36v434.43c0 9.37-1.34 18.43-3.86 26.99a94.733 94.733 0 0 1-11.33 24.82c-.84 1.32-1.72 2.61-2.63 3.88-.46.65-.93 1.29-1.41 1.92a95.123 95.123 0 0 1-9.5 10.84c-17.31 17-41.04 27.48-67.21 27.48H339.21c-4.94 0-9.79-.37-14.53-1.1a94.971 94.971 0 0 1-32.66-11.3 96.236 96.236 0 0 1-33.63-31.84c-9.56-14.92-15.11-32.65-15.11-51.69v-458.94c30.02-17.16 78.23-40.69 140.6-52.99 45.91-9.06 85.34-9.24 121.31-3.76v225.27c.75-.14 1.51-.27 2.28-.39-.14 2.48-.33 4.91-.57 7.3l-.06.54c-.06.6-.12 1.18-.2 1.77-.07.72-.16 1.43-.26 2.14-.08.66-.17 1.32-.27 1.98a84.78 84.78 0 0 1-.51 3.31c-.13.79-.27 1.56-.41 2.33v9.71c0 52.88 42.87 95.75 95.75 95.75h798.12c52.88 0 95.75-42.87 95.75-95.75v-233.24c13.81.91 28.06 2.25 42.81 4.05 3.45.42 6.93.87 10.44 1.34 89.81 12.12 161.66 36.37 208.66 55.15Z"
          style={{
            fill: "#87d687",
          }}
        />
        <path
          d="M507.47 1369.98c-.14 2.48-.33 4.91-.57 7.3l-.06.54c-.06.6-.12 1.18-.2 1.77-.07.72-.16 1.43-.26 2.14-.08.66-.17 1.32-.27 1.98a84.78 84.78 0 0 1-.51 3.31c-.13.79-.27 1.56-.41 2.33v-18.98c.75-.14 1.51-.27 2.28-.39Z"
          style={{
            fill: "#fff",
          }}
        />
        <path
          d="M1756.72 1551.31v109.48c0 52.98-42.95 95.93-95.94 95.93H339.21c-52.98 0-95.93-42.95-95.93-95.93v-54.71c34.24-21.76 87.2-49.89 155.84-64.14 127.82-26.54 207.82 16.27 318.64 39.83 278.52 59.21 313.4-96.38 606.64-42.89 61.38 11.2 165.26 37.24 312.51 27.57 51.08-3.35 92.72-10.04 119.81-15.14Z"
          style={{
            fill: "#67bf82",
          }}
        />
        <path
          d="M506.89 1352.62c-.14 2.48-.33 4.91-.57 7.3 0 .01 0 .02-.01.03-.01.17-.03.34-.05.51-.06.6-.12 1.18-.2 1.77-.07.72-.16 1.43-.26 2.14-.08.66-.17 1.32-.27 1.98a84.78 84.78 0 0 1-.51 3.31c-.13.79-.27 1.56-.41 2.33-.5 2.76-1.08 5.43-1.73 7.98-.21.82-.42 1.63-.64 2.43-.22.79-.45 1.58-.68 2.35-.24.78-.48 1.54-.72 2.29-.22.67-.45 1.33-.68 1.98-.05.17-.11.35-.18.52-.2.55-.4 1.09-.61 1.62-.04.15-.1.29-.17.44-.18.49-.37.97-.57 1.44-.76 1.85-1.56 3.61-2.42 5.27-.16.31-.31.61-.47.91-.95 1.79-1.96 3.45-3.02 4.97-.17.26-.35.51-.53.76-.36.5-.73.99-1.1 1.46-.48.6-.97 1.17-1.47 1.72-.63.7-1.28 1.36-1.94 1.96-.2.18-.4.36-.6.53-.2.18-.4.35-.6.51-.2.16-.4.32-.61.48-1.63 1.25-3.34 2.21-5.1 2.86-1.8.67-9.76 3.28-16.34-1.12-.44-.29-.87-.62-1.3-.98-.21-.18-.42-.36-.63-.56-6.13-5.81-7.27-16.5-6.48-22.7.05-.41.11-.81.19-1.22 0-.05.01-.11.02-.16.07-.33.13-.66.21-.99.04-.18.09-.37.13-.55.07-.28.15-.56.23-.84.09-.31.19-.62.3-.94.07-.22.14-.44.22-.66.15-.41.31-.82.49-1.23.14-.37.31-.74.48-1.11.01-.02.02-.04.03-.07.19-.39.38-.78.59-1.17.19-.36.38-.72.59-1.07l.09-.15c7.1-12.12 23.68-22.09 45.02-25.94.75-.14 1.51-.27 2.28-.39Z"
          className="cls-4har9"
        />
        <path
          d="m506.32 1359.92-.06.54c-.06.6-.12 1.18-.2 1.77-.07.72-.16 1.43-.26 2.14-.08.66-.17 1.32-.27 1.98a84.78 84.78 0 0 1-.51 3.31c-.13.79-.27 1.56-.41 2.33-.5 2.76-1.08 5.43-1.73 7.98-.21.82-.42 1.63-.64 2.43-.22.79-.45 1.58-.68 2.35-.24.78-.48 1.54-.72 2.29-.22.67-.45 1.33-.68 1.98-.05.17-.11.35-.18.52-.2.55-.4 1.09-.61 1.62-.04.15-.1.29-.17.44-.18.49-.37.97-.57 1.44-.76 1.85-1.56 3.61-2.42 5.27-.16.31-.31.61-.47.91-.95 1.79-1.96 3.45-3.02 4.97-.17.26-.35.51-.53.76-.36.5-.73.99-1.1 1.46-.48.6-.97 1.17-1.47 1.72-.63.7-1.28 1.36-1.94 1.96-.2.18-.4.36-.6.53-.2.18-.4.35-.6.51-.2.16-.4.32-.61.48-1.63 1.25-3.34 2.21-5.1 2.86-1.8.67-9.76 3.28-16.34-1.12-.44-.3-.87-.62-1.3-.98-.21-.18-.42-.37-.63-.57-6.13-5.8-7.27-16.49-6.48-22.69.05-.41.11-.81.19-1.22 0-.05.01-.11.02-.16.07-.33.13-.66.21-.99.04-.18.09-.37.13-.55.07-.28.15-.56.23-.84.09-.31.19-.62.3-.94.07-.22.14-.44.22-.66.15-.41.31-.82.49-1.23.14-.37.31-.74.48-1.11.01-.02.02-.04.03-.07.19-.39.38-.78.59-1.17.19-.36.38-.72.59-1.07l.09-.15c-.04.16-.07.32-.1.48-1.1 5.9-.64 15.93 4.79 21.05 1.23 1.16 2.57 1.94 3.96 2.44.49.19.99.33 1.49.45 5.04 1.14 10.19-.84 11.58-1.43 9.65-4.09 18.01-17.42 23.3-35.57a124.9 124.9 0 0 0 1.7-6.42c.01-.01.01-.02.01-.03Z"
          className="cls-4har8"
        />
        <path
          d="M467.6 1410.49c-.25-12.55 6.18-25.32 16.61-32.36-8.36 9.87-13.38 19.86-16.61 32.36Z"
          className="cls-4har10"
        />
        <path
          d="M369.78 1453.36c4.55 32.59 17.19 57.39 32.2 61.6 2.11.59 12.11 2.98 18.63-4.3 5.83-6.51 6.1-17.64 4.76-23.97-3.64-17.28-26.03-31.12-55.59-33.33Z"
          className="cls-4har9"
        />
        <path
          d="M401.97 1514.95c2.11.59 12.1 2.98 18.62-4.3 5.83-6.51 6.1-17.64 4.76-23.97-.75-3.57-2.3-6.99-4.55-10.19l.15.5c1.63 5.99 2.01 16.38-3.15 22.12-5.78 6.43-15.41 3.62-17.45 2.95-11.48-3.8-22.3-19.57-29.37-41.23 5.32 28.85 17.15 50.23 30.99 54.11Z"
          className="cls-4har8"
        />
        <path
          d="M415.23 1509.73c-4.39-12.62-10.43-22.52-19.88-31.98 11.36 6.38 19.08 19.01 19.88 31.98Z"
          className="cls-4har10"
        />
        <path
          d="M391.29 1388.66c4.55 32.59 17.19 57.39 32.2 61.6 2.11.59 12.11 2.98 18.63-4.3 5.83-6.51 6.1-17.64 4.76-23.97-3.64-17.28-26.03-31.12-55.59-33.33Z"
          className="cls-4har9"
        />
        <path
          d="M423.49 1450.26c2.11.59 12.1 2.98 18.62-4.3 5.83-6.51 6.1-17.64 4.76-23.97-.75-3.57-2.3-6.99-4.55-10.19l.15.5c1.63 5.99 2.01 16.38-3.15 22.12-5.78 6.43-15.41 3.62-17.45 2.95-11.48-3.8-22.3-19.57-29.37-41.23 5.32 28.85 17.15 50.23 30.99 54.11Z"
          className="cls-4har8"
        />
        <path
          d="M436.74 1445.03c-4.39-12.62-10.43-22.52-19.88-31.98 11.36 6.38 19.08 19.01 19.88 31.98Z"
          className="cls-4har10"
        />
        <path
          d="M354.11 1526.47c8 31.92 23.22 55.22 38.59 57.8 2.16.36 12.35 1.67 18.06-6.26 5.1-7.09 4.18-18.19 2.18-24.34-5.47-16.79-29.21-28.17-58.83-27.2Z"
          className="cls-4har9"
        />
        <path
          d="M392.7 1584.28c2.16.36 12.35 1.67 18.06-6.26 5.1-7.09 4.18-18.19 2.18-24.34-1.13-3.47-3.04-6.7-5.61-9.64.07.16.13.32.2.48 2.26 5.78 3.75 16.07-.77 22.33-5.06 7.01-14.93 5.25-17.03 4.8-11.82-2.55-24.26-17.08-33.61-37.85 8.38 28.12 22.42 48.11 36.59 50.49Z"
          className="cls-4har8"
        />
        <path
          d="M405.32 1577.67c-5.7-12.07-12.78-21.29-23.19-29.67 11.98 5.13 21 16.86 23.19 29.67Z"
          className="cls-4har10"
        />
        <path
          d="M342.77 1602.29c11.03 31 28.42 52.74 43.97 53.83 2.18.15 12.46.47 17.37-7.97 4.4-7.55 2.41-18.51-.17-24.44-7.06-16.19-31.78-25.23-61.17-21.42Z"
          className="cls-4har9"
        />
        <path
          d="M386.74 1656.12c2.18.15 12.46.47 17.37-7.97 4.4-7.55 2.41-18.51-.17-24.44-1.46-3.34-3.67-6.38-6.51-9.06.09.15.16.3.24.46 2.81 5.54 5.28 15.63 1.38 22.3-4.36 7.46-14.36 6.66-16.49 6.41-12.01-1.4-25.79-14.67-37.09-34.45 11.04 27.18 26.94 45.73 41.27 46.74Z"
          className="cls-4har8"
        />
        <path
          d="M398.66 1648.33c-6.83-11.46-14.77-19.96-25.93-27.31 12.42 3.95 22.52 14.77 25.93 27.31Z"
          className="cls-4har10"
        />
        <path
          d="M334.87 1676.56c12.64 30.39 31.13 51.18 46.72 51.46 2.19.04 12.46-.18 16.93-8.87 4-7.77 1.44-18.61-1.45-24.39-7.89-15.8-33.05-23.54-62.21-18.2Z"
          className="cls-4har9"
        />
        <path
          d="M381.59 1728.02c2.19.04 12.46-.18 16.93-8.87 4-7.77 1.44-18.61-1.45-24.39-1.63-3.26-3.99-6.18-6.98-8.71l.27.45c3.09 5.38 6.09 15.34 2.54 22.2-3.97 7.68-13.99 7.4-16.14 7.27-12.07-.77-26.52-13.3-38.84-32.47 12.44 26.57 29.29 44.26 43.66 44.52Z"
          className="cls-4har9"
        />
        <path
          d="M393.09 1719.62c-7.41-11.08-15.8-19.17-27.32-25.92 12.61 3.3 23.26 13.57 27.32 25.92Z"
          className="cls-4har10"
        />
        <path
          d="M491.37 1661.37c-22.58 23.94-47.25 36.83-61.92 31.57-2.06-.74-11.59-4.59-12.69-14.29-.99-8.68 5.24-17.91 10-22.3 12.98-11.98 39.25-10.29 64.62 5.02Z"
          className="cls-4har9"
        />
        <path
          d="M429.45 1692.94c-2.06-.74-11.59-4.58-12.69-14.29-.99-8.68 5.24-17.91 10-22.3 2.68-2.47 5.92-4.36 9.61-5.67l-.41.32c-4.8 3.94-11.13 12.18-10.24 19.86.99 8.58 10.46 11.88 12.51 12.51 11.56 3.56 29.51-3.04 47.82-16.6-21.05 20.44-43.07 31.01-56.6 26.16Z"
          className="cls-4har8"
        />
        <path
          d="M421.67 1681.01c8.17-10.11 21.77-15.94 34.73-14.55-13.19 2.23-23.85 6.81-34.73 14.55Z"
          className="cls-4har10"
        />
        <path
          d="M500.23 1589.67c-22.58 23.94-47.25 36.83-61.92 31.57-2.06-.74-11.59-4.59-12.69-14.29-.99-8.68 5.24-17.91 10-22.3 12.98-11.98 39.25-10.29 64.62 5.02Z"
          className="cls-4har9"
        />
        <path
          d="M438.31 1621.23c-2.06-.74-11.59-4.58-12.69-14.29-.99-8.68 5.24-17.91 10-22.3 2.68-2.47 5.92-4.36 9.61-5.67l-.41.32c-4.8 3.94-11.13 12.18-10.24 19.86.99 8.58 10.46 11.88 12.51 12.51 11.56 3.56 29.51-3.04 47.82-16.6-21.05 20.44-43.07 31.01-56.6 26.16Z"
          className="cls-4har8"
        />
        <path
          d="M430.53 1609.3c8.17-10.11 21.77-15.94 34.73-14.55-13.19 2.23-23.85 6.81-34.73 14.55Z"
          className="cls-4har10"
        />
        <path
          d="M511.29 1527.65c-22.58 23.94-47.25 36.83-61.92 31.57-2.06-.74-11.59-4.59-12.69-14.29-.99-8.68 5.24-17.91 10-22.3 12.98-11.98 39.25-10.29 64.62 5.02Z"
          className="cls-4har9"
        />
        <path
          d="M449.36 1559.21c-2.06-.74-11.59-4.58-12.69-14.29-.99-8.68 5.24-17.91 10-22.3 2.68-2.47 5.92-4.36 9.61-5.67l-.41.32c-4.8 3.94-11.13 12.18-10.24 19.86.99 8.58 10.46 11.88 12.51 12.51 11.56 3.56 29.51-3.04 47.82-16.6-21.05 20.44-43.07 31.01-56.6 26.16Z"
          className="cls-4har8"
        />
        <path
          d="M441.58 1547.28c8.17-10.11 21.77-15.94 34.73-14.55-13.19 2.23-23.85 6.81-34.73 14.55Z"
          className="cls-4har10"
        />
        <path
          d="M532.41 1456.91c-22.58 23.94-47.25 36.83-61.92 31.57-2.06-.74-11.59-4.59-12.69-14.29-.99-8.68 5.24-17.91 10-22.3 12.98-11.98 39.25-10.29 64.62 5.02Z"
          className="cls-4har9"
        />
        <path
          d="M470.49 1488.48c-2.06-.74-11.59-4.58-12.69-14.29-.99-8.68 5.24-17.91 10-22.3 2.68-2.47 5.92-4.36 9.61-5.67l-.41.32c-4.8 3.94-11.13 12.18-10.24 19.86.99 8.58 10.46 11.88 12.51 12.51 11.56 3.56 29.51-3.04 47.82-16.6-21.05 20.44-43.07 31.01-56.6 26.16Z"
          className="cls-4har8"
        />
        <path
          d="M462.71 1476.55c8.17-10.11 21.77-15.94 34.73-14.55-13.19 2.23-23.85 6.81-34.73 14.55ZM460.32 1428.63c-32.29 90.84-49.11 187.23-48.57 283.67 0 13.78.46 27.56 1.09 41.34-.88-10.31-1.49-20.64-1.91-30.98-3.89-99.99 12.96-200.82 49.39-294.04Z"
          className="cls-4har10"
        />
        <path
          d="M197.38 1206.71c21.87 39.21 28.52 76.59 15.65 93.52-1.81 2.38-10.72 13.2-23.8 10.65-11.7-2.28-21.15-14.18-24.91-22.16-10.26-21.8 2.72-55.29 33.06-82.01Z"
          className="cls-4har9"
        />
        <path
          d="M213.03 1300.23c-1.81 2.38-10.72 13.2-23.8 10.65-11.7-2.28-21.15-14.17-24.91-22.16-2.12-4.5-3.24-9.5-3.43-14.83.08.22.16.44.25.66 3.16 7.86 11.28 19.48 21.63 21.48 11.57 2.24 19.75-8.74 21.42-11.15 9.37-13.58 8.16-39.64-1.97-69.03 17.95 35.78 22.67 68.77 10.8 84.38Z"
          className="cls-4har8"
        />
        <path
          d="M194.31 1305.45c-9.79-14.78-11.79-34.87-4.68-51.16-2.51 18.09-.93 33.81 4.68 51.16Z"
          className="cls-4har10"
        />
        <path
          d="M110.09 1430.58c30.08 35.43 63.92 55.43 85 49.09 2.96-.89 16.69-5.61 18.96-19.22 2.03-12.17-6.07-25.65-12.45-32.19-17.42-17.85-54.59-17.42-91.5 2.31Z"
          className="cls-4har9"
        />
        <path
          d="M195.09 1479.67c2.96-.89 16.68-5.61 18.96-19.22 2.03-12.17-6.07-25.65-12.45-32.19-3.6-3.68-8.03-6.59-13.13-8.71.19.16.37.32.55.49 6.48 5.91 14.79 18.01 12.98 28.77-2.03 12.03-15.63 15.98-18.57 16.72-16.57 4.16-41.39-6.47-66.22-26.94 28.18 30.38 58.45 46.92 77.89 41.08Z"
          className="cls-4har8"
        />
        <path
          d="M206.94 1463.42c-14.78-11.73-29.47-18.97-47.91-23.09 18.38-.99 37.13 8.23 47.91 23.09Z"
          className="cls-4har10"
        />
        <path
          d="M86.79 1337.16c30.08 35.43 63.92 55.43 85 49.09 2.96-.89 16.69-5.61 18.96-19.22 2.03-12.17-6.07-25.65-12.45-32.19-17.42-17.85-54.59-17.42-91.5 2.31Z"
          className="cls-4har9"
        />
        <path
          d="M171.79 1386.25c2.96-.89 16.68-5.61 18.96-19.22 2.03-12.17-6.07-25.65-12.45-32.19-3.6-3.68-8.03-6.59-13.13-8.71.19.16.37.32.55.49 6.48 5.91 14.79 18.01 12.98 28.77-2.03 12.03-15.63 15.98-18.57 16.72-16.57 4.16-41.39-6.47-66.22-26.94 28.18 30.38 58.45 46.92 77.89 41.08Z"
          className="cls-4har8"
        />
        <path
          d="M183.64 1370c-14.78-11.73-29.47-18.97-47.91-23.09 18.38-.99 37.13 8.23 47.91 23.09Z"
          className="cls-4har10"
        />
        <path
          d="M146.73 1529.63c33.69 32.01 69.47 48.28 89.76 39.73 2.85-1.2 15.99-7.36 16.8-21.13.72-12.32-8.78-24.85-15.82-30.67-19.23-15.89-56.14-11.49-90.73 12.08Z"
          className="cls-4har9"
        />
        <path
          d="M236.48 1569.35c2.85-1.2 15.99-7.36 16.79-21.13.72-12.32-8.78-24.85-15.82-30.67-3.97-3.28-8.69-5.69-13.99-7.25l.6.42c7.07 5.18 16.63 16.32 15.98 27.21-.73 12.18-13.84 17.56-16.68 18.61-16.03 5.91-41.85-2.01-68.72-19.71 31.26 27.19 63.13 40.41 81.84 32.52Z"
          className="cls-4har8"
        />
        <path
          d="M246.53 1551.93c-15.93-10.07-31.35-15.71-50.1-17.84 18.17-2.95 37.8 4.22 50.1 17.84Z"
          className="cls-4har10"
        />
        <path
          d="M190.57 1628.62c36.61 28.62 73.79 41.38 93.16 30.92 2.72-1.47 15.21-8.86 14.69-22.65-.47-12.33-11.13-23.89-18.69-29.01-20.66-13.97-56.99-6.04-89.15 20.74Z"
          className="cls-4har9"
        />
        <path
          d="M283.73 1659.54c2.72-1.47 15.21-8.86 14.69-22.65-.47-12.33-11.12-23.89-18.69-29.01-4.27-2.88-9.2-4.83-14.62-5.87.22.12.43.24.64.36 7.54 4.48 18.12 14.65 18.52 25.55.44 12.19-12.09 18.81-14.82 20.13-15.39 7.42-41.85 2.02-70.29-13.02 33.73 24.06 66.72 34.15 84.58 24.51Z"
          className="cls-4har8"
        />
        <path
          d="M292.06 1641.23c-16.82-8.5-32.71-12.63-51.58-12.94 17.8-4.68 38.03.57 51.58 12.94Z"
          className="cls-4har10"
        />
        <path
          d="M237.34 1723.15c38.06 26.67 75.85 37.48 94.65 26.02 2.64-1.61 14.73-9.65 13.49-23.38-1.11-12.29-12.36-23.28-20.18-27.99-21.36-12.87-57.22-3.06-87.95 25.36Z"
          className="cls-4har9"
        />
        <path
          d="M331.99 1749.17c2.64-1.61 14.73-9.64 13.48-23.38-1.11-12.29-12.36-23.28-20.18-27.99-4.41-2.65-9.44-4.35-14.91-5.1l.66.33c7.76 4.08 18.86 13.68 19.82 24.55 1.08 12.15-11.09 19.41-13.75 20.87-14.98 8.22-41.69 4.2-70.88-9.33 34.94 22.27 68.41 30.63 85.75 20.06Z"
          className="cls-4har9"
        />
        <path
          d="M339.35 1730.45c-17.22-7.6-33.35-10.91-52.19-10.23 17.53-5.6 38-1.42 52.19 10.23Z"
          className="cls-4har10"
        />
        <path
          d="M412.47 1586.64c-8.82 45.63-28.48 79.66-49.96 84.49-3.02.68-17.29 3.3-25.95-7.44-7.74-9.61-7.3-25.33-4.95-34.15 6.41-24.1 39.02-41.97 80.86-42.9Z"
          className="cls-4har9"
        />
        <path
          d="M362.51 1671.13c-3.01.68-17.29 3.3-25.95-7.44-7.75-9.61-7.3-25.33-4.95-34.15 1.33-4.97 3.76-9.68 7.17-14.03-.09.23-.16.46-.24.69-2.74 8.33-4.05 22.95 2.81 31.43 7.67 9.49 21.47 6.25 24.39 5.45 16.48-4.5 32.89-25.95 44.47-55.98-9.64 40.3-27.9 69.57-47.7 74.02Z"
          className="cls-4har8"
        />
        <path
          d="M344.21 1662.79c2.1-18.23 13.91-35.48 30.4-43.63-14.04 12.64-23.29 26.17-30.4 43.63Z"
          className="cls-4har10"
        />
        <path
          d="M368.79 1494.43c-8.82 45.63-28.48 79.66-49.96 84.49-3.02.68-17.29 3.3-25.95-7.44-7.74-9.61-7.3-25.33-4.95-34.15 6.41-24.1 39.02-41.97 80.86-42.9Z"
          className="cls-4har9"
        />
        <path
          d="M318.83 1578.92c-3.01.68-17.29 3.3-25.95-7.44-7.75-9.61-7.3-25.33-4.95-34.15 1.33-4.97 3.76-9.68 7.17-14.03-.09.23-.16.46-.24.69-2.74 8.33-4.05 22.95 2.81 31.43 7.67 9.49 21.47 6.25 24.39 5.45 16.48-4.5 32.89-25.95 44.47-55.98-9.64 40.3-27.9 69.57-47.7 74.02Z"
          className="cls-4har8"
        />
        <path
          d="M300.53 1570.58c2.1-18.23 13.91-35.48 30.4-43.63-14.04 12.64-23.29 26.17-30.4 43.63Z"
          className="cls-4har10"
        />
        <path
          d="M335.04 1412.11c-8.82 45.63-28.48 79.66-49.96 84.49-3.02.68-17.29 3.3-25.95-7.44-7.74-9.61-7.3-25.33-4.95-34.15 6.41-24.1 39.02-41.97 80.86-42.9Z"
          className="cls-4har9"
        />
        <path
          d="M285.08 1496.6c-3.01.68-17.29 3.3-25.95-7.44-7.75-9.61-7.3-25.33-4.95-34.15 1.33-4.97 3.76-9.68 7.17-14.03-.09.23-.16.46-.24.69-2.74 8.33-4.05 22.95 2.81 31.43 7.67 9.49 21.47 6.25 24.39 5.45 16.48-4.5 32.89-25.95 44.47-55.98-9.64 40.3-27.9 69.57-47.7 74.02Z"
          className="cls-4har8"
        />
        <path
          d="M266.78 1488.26c2.1-18.23 13.91-35.48 30.4-43.63-14.04 12.64-23.29 26.17-30.4 43.63Z"
          className="cls-4har10"
        />
        <path
          d="M306.72 1311.78c-8.82 45.63-28.48 79.66-49.96 84.49-3.02.68-17.29 3.3-25.95-7.44-7.74-9.61-7.3-25.33-4.95-34.15 6.41-24.1 39.02-41.97 80.86-42.9Z"
          className="cls-4har9"
        />
        <path
          d="M256.76 1396.27c-3.01.68-17.29 3.3-25.95-7.44-7.75-9.61-7.3-25.33-4.95-34.15 1.33-4.97 3.76-9.68 7.17-14.03-.09.23-.16.46-.24.69-2.74 8.33-4.05 22.95 2.81 31.43 7.67 9.49 21.47 6.25 24.39 5.45 16.48-4.5 32.89-25.95 44.47-55.98-9.64 40.3-27.9 69.57-47.7 74.02Z"
          className="cls-4har8"
        />
        <path
          d="M238.46 1387.92c2.1-18.23 13.91-35.48 30.4-43.63-14.04 12.64-23.29 26.17-30.4 43.63ZM199.35 1332.59c30.22 132.76 83.11 260.42 156.71 375.02 10.42 16.44 21.4 32.52 32.58 48.46-8.85-11.63-17.4-23.48-25.72-35.49-80.3-116.3-136.49-249.27-163.58-387.99Z"
          className="cls-4har10"
        />
        <path
          d="M1793.85 1287.8c-13.79 33.5-15.63 64.15-3.82 76.57 1.66 1.75 9.76 9.62 19.93 6.38 9.1-2.9 15.53-13.33 17.78-20.08 6.15-18.46-7.27-44.18-33.89-62.87Z"
          className="cls-4har9"
        />
        <path
          d="M1790.03 1364.38c1.66 1.74 9.76 9.62 19.93 6.38 9.11-2.9 15.53-13.32 17.78-20.08 1.27-3.81 1.71-7.93 1.36-12.23-.04.19-.09.37-.14.56-1.79 6.6-7.19 16.68-15.24 19.23-9.01 2.86-16.53-5.21-18.08-7-8.72-10.05-10.15-31.1-4.81-55.64-10.99 30.39-11.7 57.33-.81 68.78Z"
          className="cls-4har8"
        />
        <path
          d="M1805.41 1366.86c6.43-12.77 6.17-29.09-1-41.53 3.67 14.31 3.86 27.08 1 41.53Z"
          className="cls-4har10"
        />
        <path
          d="M1884.02 1459.69c-20.68 31.22-45.77 50.38-63.14 47.22-2.44-.44-13.8-2.98-16.87-13.71-2.74-9.59 2.47-21.16 6.94-27 12.22-15.94 41.86-18.99 73.06-6.51Z"
          className="cls-4har9"
        />
        <path
          d="M1820.88 1506.91c-2.44-.44-13.8-2.98-16.87-13.71-2.74-9.59 2.47-21.16 6.94-27 2.52-3.29 5.79-6.03 9.65-8.2-.14.15-.26.29-.39.44-4.61 5.34-10.12 15.82-7.68 24.3 2.72 9.48 13.92 11.41 16.33 11.74 13.57 1.83 32.36-8.98 50.23-27.7-19.63 26.99-42.21 43.05-58.22 40.13Z"
          className="cls-4har8"
        />
        <path
          d="M1809.94 1494.93c10.68-10.77 21.72-17.93 36.01-22.93-14.72.88-28.8 10.01-36.01 22.93Z"
          className="cls-4har10"
        />
        <path
          d="M1893.94 1382.5c-20.68 31.22-45.77 50.38-63.14 47.22-2.44-.44-13.8-2.98-16.87-13.71-2.74-9.59 2.47-21.16 6.94-27 12.22-15.94 41.86-18.99 73.06-6.51Z"
          className="cls-4har9"
        />
        <path
          d="M1830.8 1429.71c-2.44-.44-13.8-2.98-16.87-13.71-2.74-9.59 2.47-21.16 6.94-27 2.52-3.29 5.79-6.03 9.65-8.2-.14.15-.26.29-.39.44-4.61 5.34-10.12 15.82-7.68 24.3 2.72 9.48 13.92 11.41 16.33 11.74 13.57 1.83 32.36-8.98 50.23-27.7-19.63 26.99-42.21 43.05-58.22 40.13Z"
          className="cls-4har8"
        />
        <path
          d="M1819.87 1417.74c10.68-10.77 21.72-17.93 36.01-22.93-14.72.88-28.8 10.01-36.01 22.93Z"
          className="cls-4har10"
        />
        <path
          d="M1863.99 1542.62c-23.87 28.8-50.85 45.15-67.79 40.13-2.38-.7-13.41-4.45-15.32-15.44-1.71-9.83 4.7-20.77 9.76-26.09 13.84-14.53 43.64-14.36 73.35 1.4Z"
          className="cls-4har9"
        />
        <path
          d="M1796.2 1582.75c-2.38-.7-13.41-4.45-15.32-15.44-1.71-9.83 4.69-20.77 9.76-26.09 2.86-3 6.39-5.37 10.47-7.11-.15.13-.29.26-.44.4-5.15 4.81-11.73 14.64-10.21 23.33 1.71 9.72 12.64 12.84 15 13.43 13.31 3.28 33.13-5.44 52.89-22.13-22.38 24.71-46.53 38.24-62.15 33.62Z"
          className="cls-4har8"
        />
        <path
          d="M1786.59 1569.67c11.75-9.55 23.51-15.49 38.24-18.92-14.74-.71-29.7 6.85-38.24 18.92Z"
          className="cls-4har10"
        />
        <path
          d="M1838.23 1626.17c-26.51 26.35-54.93 40-71.31 33.37-2.3-.93-12.93-5.73-13.78-16.85-.77-9.95 6.65-20.22 12.21-25.02 15.16-13.11 44.81-10.06 72.89 8.51Z"
          className="cls-4har9"
        />
        <path
          d="M1766.91 1659.53c-2.3-.93-12.93-5.73-13.78-16.85-.77-9.95 6.65-20.22 12.21-25.02 3.13-2.71 6.88-4.72 11.1-6.06-.16.11-.32.23-.47.35-5.59 4.29-13.08 13.43-12.38 22.23.77 9.84 11.36 14.01 13.65 14.82 12.93 4.56 33.5-2.2 54.76-16.89-24.63 22.42-49.97 33.55-65.08 27.43Z"
          className="cls-4har8"
        />
        <path
          d="M1758.59 1645.58c12.61-8.37 24.88-13.14 39.87-15.12-14.6-2.13-30.22 3.93-39.87 15.12Z"
          className="cls-4har10"
        />
        <path
          d="M1809.71 1706.4c-27.84 24.91-56.93 37.05-72.95 29.56-2.25-1.05-12.62-6.4-12.9-17.55-.25-9.98 7.69-19.84 13.48-24.34 15.82-12.3 45.28-7.69 72.36 12.33Z"
          className="cls-4har9"
        />
        <path
          d="M1736.76 1735.96c-2.25-1.05-12.61-6.4-12.89-17.55-.25-9.98 7.69-19.84 13.48-24.34 3.27-2.54 7.11-4.35 11.4-5.46-.17.11-.33.21-.49.33-5.8 3.99-13.75 12.72-13.52 21.54.26 9.86 10.62 14.58 12.87 15.51 12.68 5.23 33.58-.44 55.57-13.98-25.76 21.09-51.64 30.87-66.41 23.96Z"
          className="cls-4har9"
        />
        <path
          d="M1729.18 1721.59c13.01-7.68 25.54-11.81 40.6-13-14.47-2.9-30.39 2.34-40.6 13Z"
          className="cls-4har10"
        />
        <path
          d="M1657.68 1612.74c11.23 35.86 30.03 61.4 47.58 63.32 2.46.27 14.07 1.07 19.97-8.35 5.28-8.43 3.47-21.02.79-27.89-7.33-18.78-34.94-30.15-68.34-27.07Z"
          className="cls-4har9"
        />
        <path
          d="M1705.26 1676.05c2.46.27 14.07 1.07 19.97-8.35 5.28-8.43 3.47-21.02.79-27.89-1.51-3.88-3.89-7.44-7-10.62.09.18.17.35.26.53 2.95 6.44 5.34 18.07.66 25.51-5.23 8.33-16.51 6.99-18.92 6.61-13.53-2.11-28.58-17.84-40.57-40.91 11.4 31.5 28.63 53.35 44.81 55.11Z"
          className="cls-4har8"
        />
        <path
          d="M1719.06 1667.68c-3.35-14.46-14.35-27.23-28.23-32.28 12.34 8.87 20.96 18.89 28.23 32.28Z"
          className="cls-4har10"
        />
        <path
          d="M1683.95 1534.65c11.23 35.86 30.03 61.4 47.58 63.32 2.46.27 14.07 1.07 19.97-8.35 5.28-8.43 3.47-21.02.79-27.89-7.33-18.78-34.94-30.15-68.34-27.07Z"
          className="cls-4har9"
        />
        <path
          d="M1731.52 1597.97c2.46.27 14.07 1.07 19.97-8.35 5.28-8.43 3.47-21.02.79-27.89-1.51-3.88-3.89-7.44-7-10.62.09.18.17.35.26.53 2.95 6.44 5.34 18.07.66 25.51-5.23 8.33-16.51 6.99-18.92 6.61-13.53-2.11-28.58-17.84-40.57-40.91 11.4 31.5 28.63 53.35 44.81 55.11Z"
          className="cls-4har8"
        />
        <path
          d="M1745.33 1589.59c-3.35-14.46-14.35-27.23-28.23-32.28 12.34 8.87 20.96 18.89 28.23 32.28Z"
          className="cls-4har10"
        />
        <path
          d="M1703.21 1465.42c11.23 35.86 30.03 61.4 47.58 63.32 2.46.27 14.07 1.07 19.97-8.35 5.28-8.43 3.47-21.02.79-27.89-7.33-18.78-34.94-30.15-68.34-27.07Z"
          className="cls-4har9"
        />
        <path
          d="M1750.79 1528.74c2.46.27 14.07 1.07 19.97-8.35 5.28-8.43 3.47-21.02.79-27.89-1.51-3.88-3.89-7.44-7-10.62.09.18.17.35.26.53 2.95 6.44 5.34 18.07.66 25.51-5.23 8.33-16.51 6.99-18.92 6.61-13.53-2.11-28.58-17.84-40.57-40.91 11.4 31.5 28.63 53.35 44.81 55.11Z"
          className="cls-4har8"
        />
        <path
          d="M1764.59 1520.36c-3.35-14.46-14.35-27.23-28.23-32.28 12.34 8.87 20.96 18.89 28.23 32.28Z"
          className="cls-4har10"
        />
        <path
          d="M1716.5 1382.22c11.23 35.86 30.03 61.4 47.58 63.32 2.46.27 14.07 1.07 19.97-8.35 5.28-8.43 3.47-21.02.79-27.89-7.33-18.78-34.94-30.15-68.34-27.07Z"
          className="cls-4har9"
        />
        <path
          d="M1764.08 1445.54c2.46.27 14.07 1.07 19.97-8.35 5.28-8.43 3.47-21.02.79-27.89-1.51-3.88-3.89-7.44-7-10.62.09.18.17.35.26.53 2.95 6.44 5.34 18.07.66 25.51-5.23 8.33-16.51 6.99-18.92 6.61-13.53-2.11-28.58-17.84-40.57-40.91 11.4 31.5 28.63 53.35 44.81 55.11Z"
          className="cls-4har8"
        />
        <path
          d="M1777.88 1437.16c-3.35-14.46-14.35-27.23-28.23-32.28 12.34 8.87 20.96 18.89 28.23 32.28ZM1803.9 1389.12c-11.81 109.43-42.12 216.85-90.14 315.65-6.78 14.16-14.04 28.08-21.46 41.92 5.97-10.15 11.68-20.46 17.2-30.87 53.19-100.79 85.65-212.77 94.41-326.7Z"
          className="cls-4har10"
        />
        <path
          d="M1554.18 1416.49c3.36 26.43 13.32 46.68 25.38 50.33 1.69.51 9.73 2.61 15.06-3.17 4.76-5.16 5.08-14.16 4.07-19.3-2.77-14.03-20.7-25.59-44.51-27.87Z"
          className="cls-4har9"
        />
        <path
          d="M1579.56 1466.82c1.69.51 9.73 2.61 15.06-3.17 4.77-5.16 5.09-14.16 4.07-19.3-.57-2.9-1.79-5.69-3.57-8.31.04.14.08.27.11.41 1.26 4.87 1.47 13.27-2.75 17.83-4.72 5.1-12.46 2.68-14.1 2.1-9.23-3.26-17.79-16.19-23.29-33.82 4.02 23.42 13.35 40.89 24.48 44.26Z"
          className="cls-4har8"
        />
        <path
          d="M1590.29 1462.82c-.53-10.5-6.63-20.84-15.73-26.18 7.54 7.81 12.31 15.9 15.73 26.18Z"
          className="cls-4har10"
        />
        <path
          d="M1674.27 1493.59c-1.87 27.47-10.95 48.83-23.2 53.13-1.72.6-9.91 3.11-15.76-2.63-5.24-5.14-6.11-14.42-5.37-19.78 2.02-14.63 19.85-27.35 44.34-30.71Z"
          className="cls-4har9"
        />
        <path
          d="M1651.07 1546.71c-1.72.6-9.9 3.11-15.76-2.63-5.24-5.14-6.11-14.42-5.37-19.78.42-3.02 1.51-5.96 3.19-8.75l-.09.42c-1.01 5.09-.72 13.79 3.92 18.32 5.19 5.07 13.05 2.23 14.7 1.57 9.34-3.76 17.42-17.5 22.04-35.96-2.74 24.38-11.34 42.85-22.63 46.81Z"
          className="cls-4har8"
        />
        <path
          d="M1639.73 1543.03c2.91-10.77 7.36-19.35 14.68-27.74-9.09 5.91-14.77 16.86-14.68 27.74Z"
          className="cls-4har10"
        />
        <path
          d="M1652.56 1440.64c-1.87 27.47-10.95 48.83-23.2 53.13-1.72.6-9.91 3.11-15.76-2.63-5.24-5.14-6.11-14.42-5.37-19.78 2.02-14.63 19.85-27.35 44.34-30.71Z"
          className="cls-4har9"
        />
        <path
          d="M1629.36 1493.77c-1.72.6-9.9 3.11-15.76-2.63-5.24-5.14-6.11-14.42-5.37-19.78.42-3.02 1.51-5.96 3.19-8.75l-.09.42c-1.01 5.09-.72 13.79 3.92 18.32 5.19 5.07 13.05 2.23 14.7 1.57 9.34-3.76 17.42-17.5 22.04-35.96-2.74 24.38-11.34 42.85-22.63 46.81Z"
          className="cls-4har8"
        />
        <path
          d="M1618.02 1490.09c2.91-10.77 7.36-19.35 14.68-27.74-9.09 5.91-14.77 16.86-14.68 27.74Z"
          className="cls-4har10"
        />
        <path
          d="M1691.61 1553.87c-4.79 27.08-16.1 47.34-28.75 50.29-1.78.41-10.19 2.03-15.41-4.3-4.67-5.66-4.55-14.98-3.24-20.22 3.57-14.31 22.67-25.04 47.39-25.76Z"
          className="cls-4har9"
        />
        <path
          d="M1662.86 1604.16c-1.78.41-10.19 2.03-15.4-4.3-4.67-5.66-4.55-14.98-3.24-20.22.74-2.95 2.14-5.76 4.11-8.35-.05.14-.09.27-.14.41-1.54 4.95-2.18 13.62 1.95 18.62 4.62 5.59 12.74 3.62 14.47 3.13 9.7-2.74 19.2-15.52 25.77-33.36-5.33 23.93-15.85 41.35-27.51 44.07Z"
          className="cls-4har8"
        />
        <path
          d="M1651.96 1599.29c4.04-10.38 9.4-18.45 17.57-25.99-9.68 4.9-16.5 15.17-17.57 25.99Z"
          className="cls-4har10"
        />
        <path
          d="M1705.5 1616.64c-7.37 26.47-20.57 45.53-33.46 47.24-1.81.24-10.35 1.04-14.94-5.76-4.11-6.08-3.09-15.34-1.29-20.43 4.93-13.89 24.99-22.72 49.68-21.05Z"
          className="cls-4har9"
        />
        <path
          d="M1672.04 1663.88c-1.81.24-10.34 1.03-14.93-5.76-4.11-6.08-3.1-15.34-1.29-20.43 1.02-2.87 2.68-5.52 4.89-7.9-.06.13-.12.26-.18.4-2.01 4.77-3.48 13.33.16 18.71 4.07 6.01 12.35 4.83 14.11 4.51 9.92-1.79 20.61-13.58 28.87-30.7-7.6 23.28-19.75 39.6-31.63 41.18Z"
          className="cls-4har8"
        />
        <path
          d="M1661.65 1657.99c5.02-9.93 11.13-17.44 19.99-24.15-10.11 3.94-17.89 13.5-19.99 24.15Z"
          className="cls-4har10"
        />
        <path
          d="M1716.43 1678.28c-8.74 26.04-22.92 44.37-35.89 45.4-1.82.15-10.39.49-14.62-6.53-3.79-6.29-2.29-15.47-.23-20.46 5.64-13.61 26.15-21.37 50.73-18.41Z"
          className="cls-4har9"
        />
        <path
          d="M1680.54 1723.69c-1.82.15-10.39.49-14.62-6.54-3.79-6.29-2.29-15.47-.23-20.46 1.17-2.81 2.96-5.37 5.3-7.63-.07.13-.13.26-.2.39-2.26 4.66-4.17 13.13-.81 18.68 3.75 6.21 12.09 5.46 13.86 5.24 10.01-1.27 21.3-12.48 30.44-29.13-8.8 22.84-21.79 38.49-33.74 39.45Z"
          className="cls-4har9"
        />
        <path
          d="M1670.47 1717.26c5.52-9.64 12.03-16.83 21.23-23.06-10.31 3.41-18.57 12.54-21.23 23.06Z"
          className="cls-4har10"
        />
        <path
          d="M1585.21 1673.66c20.21 18.84 41.51 28.34 53.42 23.18 1.67-.72 9.38-4.43 9.73-12.59.31-7.31-5.42-14.7-9.63-18.12-11.51-9.34-33.29-6.58-53.52 7.53Z"
          className="cls-4har9"
        />
        <path
          d="M1638.63 1696.84c1.67-.72 9.38-4.43 9.73-12.59.31-7.31-5.42-14.7-9.63-18.12-2.38-1.93-5.19-3.34-8.33-4.24.12.08.24.16.36.25 4.23 3.04 9.98 9.61 9.69 16.07-.32 7.22-8.02 10.47-9.69 11.1-9.42 3.57-24.75-1.02-40.8-11.4 18.73 15.99 37.69 23.69 48.67 18.94Z"
          className="cls-4har8"
        />
        <path
          d="M1644.41 1686.47c-7.4-8.02-19.07-12.19-29.78-10.37 11.11 1.19 20.26 4.46 29.78 10.37Z"
          className="cls-4har10"
        />
        <path
          d="M1573.63 1614.21c20.21 18.84 41.51 28.34 53.42 23.18 1.67-.72 9.38-4.43 9.73-12.59.31-7.31-5.42-14.7-9.63-18.12-11.51-9.34-33.29-6.58-53.52 7.53Z"
          className="cls-4har9"
        />
        <path
          d="M1627.05 1637.39c1.67-.72 9.38-4.43 9.73-12.59.31-7.31-5.42-14.7-9.63-18.12-2.38-1.93-5.19-3.34-8.33-4.24.12.08.24.16.36.25 4.23 3.04 9.98 9.61 9.69 16.07-.32 7.22-8.02 10.47-9.69 11.1-9.42 3.57-24.75-1.02-40.8-11.4 18.73 15.99 37.69 23.69 48.67 18.94Z"
          className="cls-4har8"
        />
        <path
          d="M1632.82 1627.02c-7.4-8.02-19.07-12.19-29.78-10.37 11.11 1.19 20.26 4.46 29.78 10.37Z"
          className="cls-4har10"
        />
        <path
          d="M1560.79 1562.96c20.21 18.84 41.51 28.34 53.42 23.18 1.67-.72 9.38-4.43 9.73-12.59.31-7.31-5.42-14.7-9.63-18.12-11.51-9.34-33.29-6.58-53.52 7.53Z"
          className="cls-4har9"
        />
        <path
          d="M1614.2 1586.14c1.67-.72 9.38-4.43 9.73-12.59.31-7.31-5.42-14.7-9.63-18.12-2.38-1.93-5.19-3.34-8.33-4.24.12.08.24.16.36.25 4.23 3.04 9.98 9.61 9.69 16.07-.32 7.22-8.02 10.47-9.69 11.1-9.42 3.57-24.75-1.02-40.8-11.4 18.73 15.99 37.69 23.69 48.67 18.94Z"
          className="cls-4har8"
        />
        <path
          d="M1619.98 1575.77c-7.4-8.02-19.07-12.19-29.78-10.37 11.11 1.19 20.26 4.46 29.78 10.37Z"
          className="cls-4har10"
        />
        <path
          d="M1539.05 1504.94c20.21 18.84 41.51 28.34 53.42 23.18 1.67-.72 9.38-4.43 9.73-12.59.31-7.31-5.42-14.7-9.63-18.12-11.51-9.34-33.29-6.58-53.52 7.53Z"
          className="cls-4har9"
        />
        <path
          d="M1592.46 1528.13c1.67-.72 9.38-4.43 9.73-12.59.31-7.31-5.42-14.7-9.63-18.12-2.38-1.93-5.19-3.34-8.33-4.24.12.08.24.16.36.25 4.23 3.04 9.98 9.61 9.69 16.07-.32 7.22-8.02 10.47-9.69 11.1-9.42 3.57-24.75-1.02-40.8-11.4 18.73 15.99 37.69 23.69 48.67 18.94Z"
          className="cls-4har8"
        />
        <path
          d="M1598.24 1517.76c-7.4-8.02-19.07-12.19-29.78-10.37 11.11 1.19 20.26 4.46 29.78 10.37ZM1597.42 1477.59c32.22 74.24 51.87 153.91 57.08 234.52.81 11.51 1.23 23.05 1.51 34.59.13-8.66.03-17.32-.22-25.98-2.62-83.75-22.57-167.12-58.37-243.13Z"
          className="cls-4har10"
        />
        <path
          d="M1434.3 1533.12c6.3 18.43 16.42 31.47 25.6 32.31 1.29.12 7.36.43 10.32-4.49 2.65-4.4 1.55-10.89.07-14.42-4.05-9.64-18.6-15.28-35.99-13.4Z"
          className="cls-4har9"
        />
        <path
          d="M1459.9 1565.43c1.29.12 7.35.43 10.32-4.49 2.65-4.4 1.56-10.89.07-14.42-.84-1.99-2.12-3.81-3.78-5.43.05.09.09.18.14.27 1.62 3.3 3.01 9.29.66 13.18-2.63 4.35-8.53 3.75-9.79 3.58-7.09-.97-15.13-8.97-21.67-20.79 6.33 16.18 15.59 27.32 24.06 28.09Z"
          className="cls-4har8"
        />
        <path
          d="M1467 1560.98c-1.93-7.44-7.82-13.95-15.13-16.44 6.55 4.48 11.16 9.58 15.13 16.44Z"
          className="cls-4har10"
        />
        <path
          d="M1531.69 1570.65c2.71 19.95-.64 36.59-8.79 41.47-1.14.69-6.64 3.69-11.68.44-4.51-2.91-6.5-9.43-6.76-13.38-.71-10.77 10.19-22.51 27.23-28.53Z"
          className="cls-4har9"
        />
        <path
          d="M1522.9 1612.12c-1.14.69-6.64 3.69-11.68.44-4.51-2.91-6.51-9.43-6.76-13.38-.15-2.22.2-4.49 1-6.73v.32c.03 3.79 1.52 9.98 5.51 12.54 4.46 2.87 9.67-.32 10.76-1.04 6.14-4.07 9.9-15.1 10.49-29.01 1.63 17.87-1.8 32.36-9.31 36.86Z"
          className="cls-4har8"
        />
        <path
          d="M1514.23 1611.16c.5-8.14 2.42-14.95 6.43-22.04-5.64 5.58-8.09 14.26-6.43 22.04Z"
          className="cls-4har10"
        />
        <path
          d="M1508.34 1535.92c2.71 19.95-.64 36.59-8.79 41.47-1.14.69-6.64 3.69-11.68.44-4.51-2.91-6.5-9.43-6.76-13.38-.71-10.77 10.19-22.51 27.23-28.53Z"
          className="cls-4har9"
        />
        <path
          d="M1499.55 1577.39c-1.14.69-6.64 3.69-11.68.44-4.51-2.91-6.51-9.43-6.76-13.38-.15-2.22.2-4.49 1-6.73v.32c.03 3.79 1.52 9.98 5.51 12.54 4.46 2.87 9.67-.32 10.76-1.04 6.14-4.07 9.9-15.1 10.49-29.01 1.63 17.87-1.8 32.36-9.31 36.86Z"
          className="cls-4har8"
        />
        <path
          d="M1490.88 1576.43c.5-8.14 2.42-14.95 6.43-22.04-5.64 5.58-8.09 14.26-6.43 22.04Z"
          className="cls-4har10"
        />
        <path
          d="M1552.99 1611.27c.56 20.11-4.55 36.28-13.18 40.26-1.21.56-7 2.95-11.67-.81-4.18-3.37-5.47-10.06-5.3-14.01.45-10.78 12.55-21.28 30.15-25.44Z"
          className="cls-4har9"
        />
        <path
          d="M1539.81 1651.53c-1.21.56-7 2.95-11.67-.81-4.18-3.37-5.47-10.06-5.3-14.01.09-2.22.68-4.44 1.71-6.58-.01.11-.03.21-.04.32-.38 3.77.44 10.08 4.14 13.05 4.13 3.33 9.66.71 10.82.11 6.54-3.39 11.47-13.95 13.54-27.69-.29 17.92-5.26 31.96-13.21 35.62Z"
          className="cls-4har8"
        />
        <path
          d="M1531.29 1649.65c1.36-8.03 4.01-14.6 8.75-21.2-6.21 4.94-9.58 13.3-8.75 21.2Z"
          className="cls-4har10"
        />
        <path
          d="M1572.19 1654.18c-1.38 20.05-8.03 35.64-17 38.77-1.26.44-7.26 2.27-11.55-1.93-3.84-3.75-4.48-10.53-3.93-14.44 1.48-10.68 14.55-19.95 32.48-22.4Z"
          className="cls-4har9"
        />
        <path
          d="M1555.19 1692.95c-1.26.44-7.26 2.27-11.55-1.93-3.84-3.75-4.48-10.53-3.93-14.44.31-2.2 1.11-4.35 2.34-6.38-.02.1-.05.21-.07.31-.74 3.71-.53 10.06 2.87 13.37 3.8 3.7 9.56 1.64 10.77 1.15 6.84-2.74 12.76-12.77 16.15-26.24-2.01 17.8-8.31 31.27-16.59 34.16Z"
          className="cls-4har8"
        />
        <path
          d="M1546.88 1690.26c2.13-7.85 5.4-14.13 10.76-20.25-6.66 4.31-10.82 12.3-10.76 20.25Z"
          className="cls-4har10"
        />
        <path
          d="M1589.11 1696.73c-2.42 19.94-9.88 35.16-19.01 37.81-1.28.37-7.37 1.88-11.44-2.53-3.64-3.94-3.92-10.75-3.18-14.62 2.04-10.58 15.58-19.16 33.63-20.67Z"
          className="cls-4har9"
        />
        <path
          d="M1570.09 1734.54c-1.28.37-7.37 1.88-11.44-2.53-3.64-3.94-3.92-10.74-3.18-14.62.42-2.18 1.33-4.28 2.67-6.25-.03.1-.06.2-.08.31-.93 3.67-1.05 10.02 2.17 13.5 3.6 3.9 9.46 2.13 10.7 1.71 6.98-2.38 13.42-12.08 17.51-25.35-2.94 17.66-9.94 30.78-18.36 33.23Z"
          className="cls-4har9"
        />
        <path
          d="M1561.93 1731.42c2.54-7.72 6.14-13.83 11.81-19.65-6.88 3.96-11.46 11.72-11.81 19.65Z"
          className="cls-4har10"
        />
        <path
          d="M1494.44 1712.76c17.25 10.51 33.91 14.18 41.68 8.73 1.09-.76 6.07-4.56 5.11-10.46-.85-5.28-6.05-9.73-9.57-11.56-9.62-4.99-24.81.19-37.22 13.28Z"
          className="cls-4har9"
        />
        <path
          d="M1536.12 1721.49c1.09-.76 6.07-4.55 5.11-10.46-.85-5.28-6.05-9.73-9.57-11.56-1.99-1.03-4.21-1.63-6.59-1.81.1.04.2.08.29.13 3.48 1.56 8.57 5.41 9.31 10.08.84 5.22-4.2 8.68-5.3 9.38-6.22 3.94-17.88 2.92-30.9-2.16 15.77 8.69 30.49 11.42 37.65 6.39Z"
          className="cls-4har8"
        />
        <path
          d="M1538.73 1713.21c-6.48-4.66-15.45-5.92-22.86-3.04 8.14-.79 15.17.21 22.86 3.04Z"
          className="cls-4har10"
        />
        <path
          d="M1477.38 1671.88c17.25 10.51 33.91 14.18 41.68 8.73 1.09-.76 6.07-4.56 5.11-10.46-.85-5.28-6.05-9.73-9.57-11.56-9.62-4.99-24.81.19-37.22 13.28Z"
          className="cls-4har9"
        />
        <path
          d="M1519.06 1680.61c1.09-.76 6.07-4.55 5.11-10.46-.85-5.28-6.05-9.73-9.57-11.56-1.99-1.03-4.21-1.63-6.59-1.81.1.04.2.08.29.13 3.48 1.56 8.57 5.41 9.31 10.08.84 5.22-4.2 8.68-5.3 9.38-6.22 3.94-17.88 2.92-30.9-2.16 15.77 8.69 30.49 11.42 37.65 6.39Z"
          className="cls-4har8"
        />
        <path
          d="M1521.67 1672.33c-6.48-4.66-15.45-5.92-22.86-3.04 8.14-.79 15.17.21 22.86 3.04Z"
          className="cls-4har10"
        />
        <path
          d="M1460.63 1637.06c17.25 10.51 33.91 14.18 41.68 8.73 1.09-.76 6.07-4.56 5.11-10.46-.85-5.28-6.05-9.73-9.57-11.56-9.62-4.99-24.81.19-37.22 13.28Z"
          className="cls-4har9"
        />
        <path
          d="M1502.3 1645.79c1.09-.76 6.07-4.55 5.11-10.46-.85-5.28-6.05-9.73-9.57-11.56-1.99-1.03-4.21-1.63-6.59-1.81.1.04.2.08.29.13 3.48 1.56 8.57 5.41 9.31 10.08.84 5.22-4.2 8.68-5.3 9.38-6.22 3.94-17.88 2.92-30.9-2.16 15.77 8.69 30.49 11.42 37.65 6.39Z"
          className="cls-4har8"
        />
        <path
          d="M1504.91 1637.51c-6.48-4.66-15.45-5.92-22.86-3.04 8.14-.79 15.17.21 22.86 3.04Z"
          className="cls-4har10"
        />
        <path
          d="M1436.5 1598.71c17.25 10.51 33.91 14.18 41.68 8.73 1.09-.76 6.07-4.56 5.11-10.46-.85-5.28-6.05-9.73-9.57-11.56-9.62-4.99-24.81.19-37.22 13.28Z"
          className="cls-4har9"
        />
        <path
          d="M1478.18 1607.44c1.09-.76 6.07-4.55 5.11-10.46-.85-5.28-6.05-9.73-9.57-11.56-1.99-1.03-4.21-1.63-6.59-1.81.1.04.2.08.29.13 3.48 1.56 8.57 5.41 9.31 10.08.84 5.22-4.2 8.68-5.3 9.38-6.22 3.94-17.88 2.92-30.9-2.16 15.77 8.69 30.49 11.42 37.65 6.39Z"
          className="cls-4har8"
        />
        <path
          d="M1480.79 1599.17c-6.48-4.66-15.45-5.92-22.86-3.04 8.14-.79 15.17.21 22.86 3.04ZM1474.28 1570.52c34.02 48.42 59.84 102.6 75.45 159.57 2.28 8.13 4.28 16.33 6.18 24.56-1.19-6.22-2.53-12.41-3.99-18.58-14.22-59.6-40.8-116.38-77.65-165.55Z"
          className="cls-4har10"
        />
        {children}
      </g>
    </svg>
  );
}
